import { useUpdateUserSettingsMutation } from 'shared/hooks/queries/use-update-user-settings-mutation';

export const useUpdateUserSettings = () => {
  const { mutate: updateSettings } = useUpdateUserSettingsMutation();

  return updateSettings;
};
